import {
	IonButton,
	IonCol,
	IonImg,
	IonLabel,
	IonLoading,
	isPlatform,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import PageHeading from "../../CustomComponents/PageHeading";
import "../Booking/BookingDetails.scss";
import "../Booking/MyBookings.scss";
import * as constants from "../../../constants";
import MyBookingsStatusCard from "./MyBookingsStatusCard";
import { connect } from "react-redux";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import {
	addItemToCart,
	fetchBookings,
	getCartItemsList,
	getMultiServiceData,
	fetchFeedback,
	getFeedback,
	updateParticularBookingDetails,
	updateReservationParticularBookingDetails,
} from "../../../Store/Actions";
import moment from "moment";
import { ToastMessage } from "../../../utils/toastMessage";
import { checkForPlural } from "../../../utils";
import FeedbackModal from "../../Portal/Booking/feedback";
import { COLLECTIONS, updateDoc } from "../../../firebase";
import { book } from "ionicons/icons";

const MyBookings: React.FC = (props: any) => {
	const [bookings, setBookings] = useState([]) as any;
	const [loader, setLoader] = React.useState(true);
	const [showReschedulePopUp, setReschedulePopUp] = useState(false);
	const [addedBookedItemsCount, setBookedItemsCount] = useState(0);
	const [bookedItemsAddedPrice, setBookedItemsPrice] = useState(0);
	const [firstServiceImages, setFirstServiceImages] = useState<any>([]);
	const [activeBookings, setActiveBooking] = useState([]);
	const [bookedItemDetailsList, setBookedItemDetailsList] = useState([]) as any;
	const [showFeedback, setShowFeedBack] = useState(false);
	const [idOfBooking, setIdOfBooking] = useState("");
	const [toast, setToast] = useState({
		showToast: false,
		toastMessage: "",
		severity: "",
	});
	// useEffect(() => {
	//   getBookingList();
	// }, [props.userVehiclesList]);

	useEffect(() => {
		// getServiceIds();
		if (activeBookings.length > 0) {
			setLoader(false);
		}
	}, [bookings, activeBookings]);

	useEffect(() => {
		const fetchBookingsDetails = async () => {
			if (props.bookingList.length && !!props.sliderCatelogVehicleId) {
				const data = await getBookingList();
				await setActiveBooking(
					props.bookingList.filter((ele: any) => {
						if (
							ele.userVehicleId === props.sliderCatelogVehicleId &&
							ele.status === "InProgress"
						)
							return ele;
					})
				);
				await setBookings(
					props.bookingList
						.filter(
							(ele: any) =>
								ele.userVehicleId === props.sliderCatelogVehicleId &&
								ele.status !== "InProgress"
						)
						.map((ele: any, index: any) => ({
							...ele,
							...data[index],
						}))
				);
			}
			if (props.bookingList.length && !!props.sliderCatelogVehicleId) {
				setLoader(false);
				props.updateParticularBookingDetails(
					props.bookingList.filter((ele: any) => {
						if (
							ele.userVehicleId === props.sliderCatelogVehicleId &&
							ele.status === "InProgress"
						)
							return ele;
					})
				);

				props.updateReservationParticularBookingDetails(
					props.bookingList.filter((ele: any) => {
						if (
							ele.userVehicleId === props.sliderCatelogVehicleId &&
							ele.status === "InProgress"
						)
							return ele;
					})
				);
			}

			if (bookings.length > 0) {
				setLoader(false);
			}

			if (!bookings.length && !activeBookings.length) {
				setLoader(false);
			}
		};
		fetchBookingsDetails();
	}, [props.sliderCatelogVehicleId, props.bookingList]);

	const getBookingList = async () => {
		console.log("122 .......", props);
		const firstItemIds = props.bookingList
			.filter((ele: any) => {
				if (
					props.sliderCatelogVehicleId === ele.userVehicleId &&
					ele.status !== "InProgress"
				) {
					return ele;
				}
			})
			.map((bkitem: any, ind: any) => {
				if (!!bkitem.items && !!bkitem.items.length) {
					let ids = bkitem.items.map((items: any, inx: any) => {
						if (!!items.serviceId && items.serviceId !== null) {
							return items.serviceId;
						}
					});

					return ids;
				}
			});

		const vMake = props.userVehiclesList.find(
			(item: any) => item.catalogVehicleId === props.sliderCatelogVehicleId
		);

		console.log("GMS = Make ==== 03", vMake);

		if ((firstItemIds || []).length) {
			const firstItemDets = await props.getMultiServiceData({
				serviceIdList: firstItemIds.filter((ele: any) => ele),
				clientName: constants.CLIENT_NAME,
				make: vMake.make,
			});
			if (!!firstItemDets) {
				const { data: first_item_details = [] } = firstItemDets;
				const firstItemImgs = first_item_details.map((val: any, index: any) => {
					return val.service;
				});
				setFirstServiceImages(firstItemImgs);
				return firstItemImgs;
			}
		}
	};

	const addBookingItemsToCart = (items: any) => {
		if (
			!(props.userAddressList || []).length &&
			props.globalSettings[0].workshopListingModel !== "Segment"
		) {
			setToast({
				showToast: true,
				toastMessage: "Please add address before booking",
				severity: "warning",
			});
			return;
		}
		setBookedItemsCount(0);
		const bookedToCart = [] as any;
		const modified = items.map((it: any) => {
			const { cartItemId, images, ...rest } = it;
			// delete it.cartItemId;
			// delete it.images;
			return { ...rest, recommended: true };
		});

		const idsOfCartItems = props.service_data.map((ele: any) => ele.serviceId);
		const idsOfBookedItems = modified.map((val: any) => val.serviceId);

		try {
			if (idsOfBookedItems.every((id: any) => idsOfCartItems.includes(id))) {
				throw Error(constants.SERVICE_ALREADY_ADDED);
			} else {
				modified.map(async (postBody: any) => {
					if (
						!props.service_data
							.map((ele: any) => ele.serviceId)
							.includes(postBody.serviceId)
					) {
						await props.addItemToCart(postBody);
						await props.getCartItemsList();
						bookedToCart.push(postBody);
						const bkedItemsPrice = bookedToCart.reduce((acc: any, curr: any) => {
							return acc + Number(curr.appliedPrice.amount);
						}, 0);
						setBookedItemsCount(bookedToCart.length);
						setBookedItemsPrice(bkedItemsPrice);
					}
				});
				const userDoc = {
					settings: { ...props.settings, workshopId: modified[0].workshopId },
				};
				updateDoc(props.uid, userDoc, COLLECTIONS.USERS);
			}
		} catch (e: any) {
			setToast({
				showToast: true,
				toastMessage: e.message,
				severity: "warning",
			});
		}
	};

	// console.log("GMS = Make ==== 225", vMake);

	const getServiceIds = async () => {
		if (bookings.length) {
			const bookedServiceIds = bookings
				.map((ele: any) => {
					if (ele.items.length) {
						return ele.items[0].serviceId;
					}
				})
				.filter((ele: any) => ele);

			const vMake = props.userVehiclesList.find(
				(item: any) => item.catalogVehicleId === props.sliderCatelogVehicleId
			);

			console.log("GMS = Make ==== 05", vMake);
			

			const bookedItemDetails = await props.getMultiServiceData({
				serviceIdList: bookedServiceIds,
				clientName: constants.CLIENT_NAME,
				make: vMake.make,
			});
			const { data } = bookedItemDetails;
			setBookedItemDetailsList(data);
		}
	};

	const handleFeedback = async (details: any) => {
		await props.fetchFeedback();
		if (details.isFeedbackGiven) {
			await props.getFeedback(details.bookingId);
		}
		setShowFeedBack(true);
		setIdOfBooking(details.bookingId);
	};

	return (
		<>
			<IonCol className="middle_panle res_bg_color ">
				{isPlatform("ios") && <div className="ios_statusbar_color" />}
				<div className="my_bookings_top_div">
					<div className="mar_top_30 my-bookings-heading-margin">
						<PageHeading
							mainHeader="My Bookings"
							navigation={props}
							showCart={true}
							cssClass={"bookings_header"}
						/>
					</div>
					{!bookings.length && !activeBookings.length && !loader && (
						<div className="center_text">
							<IonLabel className="no_bookings_text">No Bookings Available</IonLabel>
						</div>
					)}
					{!!(activeBookings || []).length &&
						activeBookings.map((ele: any, ind: any) => (
							<MyBookingsStatusCard
								{...props}
								{...ele}
								setModalValue={(val: any) => setReschedulePopUp(val)}
								modalOpenValue={showReschedulePopUp}
								roundStyle={true}
								key={ind}
							/>
						))}

					{!!bookings.length && (
						<div
							className="mrgn_top"
							style={{
								marginTop: !!(activeBookings || []).length
									? 30
									: isPlatform("ios")
									? 100
									: 70,
							}}
						>
							<IonLabel className="bkng_history">{constants.BOOKING_HISTORY}</IonLabel>
						</div>
					)}
				</div>
				<div className={"my_bookings_bottom_div"}>
					{(bookings || []).map((bookSer: any, ind: any) => {
						return (
							<div
								key={ind}
								className="rec_ser_prnt width_100per last_ele cursor_none margin-bottom-zero"
							>
								<div
									className={
										bookSer.status === "Completed"
											? "recomended_div completed_status_div"
											: "recomended_div cancelled_container"
									}
								>
									<IonLabel
										className={
											bookSer.status === "Completed"
												? "rec_recom"
												: "cancelled_status_div"
										}
									>
										{bookSer.status}
									</IonLabel>
								</div>
								<div className="rec_ser_img_div">
									<img
										src={
											bookSer.hasOwnProperty("imageUrl") && !!bookSer.imageUrl
												? bookSer.imageUrl
												: "/images/brake_image.svg"
										}
										className="rec_ser_image"
									/>
									<div
										className="rec_row_wrap cursor_pointer"
										onClick={() =>
											props.history.push({
												pathname: "/portal/booking_details",
												state: {
													idOfBooking: bookSer.bookingId,
												},
											})
										}
									>
										<div className="tag_desc">
											<IonLabel className="rec_ser_problem">
												{bookSer.bookingCode}
											</IonLabel>
											<IonLabel className="rec_ser_sub">
												Booked on{" "}
												{/* <IonLabel className="bked_date_text">
                          {moment(
                            new Date(bookSer.createdAt.seconds * 1000)
                          ).format("DD MMM YYYY")}
                        </IonLabel> */}
												<IonLabel className="bked_date_text">
													{moment(
														moment(
															`${bookSer.events[0].updatedAt}`,
															"DD-MM-YYYY hh:mm:ss"
														)
													).format("DD MMM YYYY")}
												</IonLabel>
											</IonLabel>
										</div>
										<div className="rec_ser_fea_div">
											{bookSer.hasOwnProperty("displayTags") &&
												!!bookSer.displayTags.length &&
												bookSer.displayTags.map((head: any, ind: any) => (
													<div key={head} className="rec_ser_feature">
														<IonLabel className="rec_ser_sub">{head}</IonLabel>
													</div>
												))}
										</div>
									</div>

									<div className="rec_ser_price_div right_55">
										<IonLabel className="rec_ser_sub">{"Total Bill"}</IonLabel>
										<IonLabel className="rec_ser_price">{`${
											constants.RupeeSymbol
										} ${Number(bookSer.estimate.totalEstimated)}`}</IonLabel>
									</div>
								</div>
								<div className="bked_dashed_line" />
								<div className="bked_action_cont">
									<div className="bked_action_btns">
										{/* <div
											className="cart_action_cont cursor_pointer"
											onClick={() => addBookingItemsToCart(bookSer.items)}
										>
											<IonLabel className="bked_addtocart_text">
												{constants.ADD_TO_CART}
											</IonLabel>
										</div> */}
										<div
											className="help_action_cont cursor_pointer"
											onClick={() => props.history.push("/portal/help-and-support")}
										>
											<IonLabel className="bked_help_text">{constants.HELP}</IonLabel>
										</div>
									</div>
									{bookSer.status === "Completed" && (
										<div className="bked_fdb_grp">
											{/* <div
                        // className="bked_fdb cursor_pointer"
                        className="cart_action_view_invoice cursor_pointer"
                        style={{ paddingLeft: 15, paddingRight: 10 }}
                        onClick={() => {
                          if (window.cordova) {
                            const target = "_system";
                            const options =
                              "location=no,clearcache=yes,hideurlbar=yes,hidenavigationbuttons=yes,cleardata=yes,toolbarposition=top";
                            // InAppBrowser.create(bookSer.invoiceUrl, target, options);
                            window.open(bookSer.invoiceUrl, target, options);
                          } else {
                            window.open(bookSer.invoiceUrl);
                          }
                        }}
                      >
                        <IonLabel className="bked_fdb">Invoice</IonLabel>
                      </div> */}

											<IonLabel
												className="bked_invoice_text invoice_action_cont"
												onClick={() => {
													if (window.cordova) {
														const target = "_system";
														const options =
															"location=no,clearcache=yes,hideurlbar=yes,hidenavigationbuttons=yes,cleardata=yes,toolbarposition=top";
														// InAppBrowser.create(bookSer.invoiceUrl, target, options);
														window.open(bookSer.invoiceUrl, target, options);
													} else {
														window.open(bookSer.invoiceUrl);
													}
												}}
											>
												Invoice
											</IonLabel>

											<IonLabel
												className="bked_fdb cursor_pointer"
												onClick={() => handleFeedback(bookSer)}
											>
												{bookSer.isFeedbackGiven
													? constants.VIEW_FEEDBACK
													: constants.GIVE_FEEDBACK}
											</IonLabel>
										</div>
									)}
								</div>
							</div>
						);
					})}
				</div>
				{/* {Boolean(props.service_data.length) && (
          <div className="book-service-cart-details">
            <div className="sd_col">
              <IonLabel className="sd_escost">
                {props.service_data.length}
                {checkForPlural(
                  props.service_data.length,
                  constants.TWO_SERVICES
                )}{" "}
                {constants.ADDED}
              </IonLabel>
              <IonLabel className="sd_price">{` ${constants.RupeeSymbol} ${props.cart_estimates.totalEstimated}`}</IonLabel>
            </div>
            <IonButton
              color="light"
              className="service-details-continue-button"
              onClick={() => props.history.push("/portal/cart")}
            >
              <IonLabel color="primary">{constants.CONTINUE}</IonLabel>
            </IonButton>
          </div>
        )} */}
			</IonCol>
			<ToastMessage
				showToast={toast.showToast}
				ToastMessage={toast.toastMessage}
				severity={toast.severity}
				onDidDismiss={() => {
					setToast({
						showToast: false,
						toastMessage: "",
						severity: "",
					});
				}}
			/>
			<FeedbackModal
				{...props}
				visible={showFeedback}
				close={() => setShowFeedBack(false)}
				bookingId={idOfBooking}
			/>
			{addedBookedItemsCount > 0 && (
				<div className="confirm_page-footer my_bkngs_footer">
					<div className="sd_show_cost confirm_btn_bottom">
						<div className="sd_col">
							<IonLabel className="sd_escost">{`${addedBookedItemsCount} ${
								addedBookedItemsCount > 1 ? "Services" : "Service"
							} Added`}</IonLabel>
							<IonLabel className="pay_value">
								{constants.RupeeSymbol} {bookedItemsAddedPrice}
							</IonLabel>
						</div>
						<IonButton
							color="light"
							className="service-details-continue-button"
							onClick={() => {
								props.history.push("/portal/cart");
							}}
						>
							<IonLabel color="primary">{constants.VIEW_CART}</IonLabel>
						</IonButton>
					</div>
				</div>
			)}
			<IonLoading
				cssClass="my-custom-class"
				isOpen={loader}
				onDidDismiss={() => setLoader(false)}
				message={"Please wait... <br>Loading bookings..."}
				// duration={5000}
			/>
		</>
	);
};
export default connect(
	({ booking, cart, userInfo, workshop, auth }: any) => {
		const { service_data, cart_items, cart_estimates } = cart;
		const { globalSettings } = workshop;
		return {
			...auth,
			...userInfo,
			...booking,
			service_data,
			cart_items,
			cart_estimates,
			globalSettings,
		};
	},
	{
		fetchBookings,
		getMultiServiceData,
		addItemToCart,
		getCartItemsList,
		fetchFeedback,
		getFeedback,
		updateParticularBookingDetails,
		updateReservationParticularBookingDetails,
	}
)(MyBookings);
